import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconArrowPathDown"><Path d="M4.69986 14.6C4.20544 13.9408 4.67582 13 5.49986 13H7.99986V4.5C7.99986 3.11929 9.11915 2 10.4999 2H13.4999C14.8806 2 15.9999 3.11929 15.9999 4.5V13H18.4999C19.3239 13 19.7943 13.9408 19.2999 14.6L13.5999 22.2C12.7999 23.2667 11.1999 23.2667 10.3999 22.2L4.69986 14.6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathDown;
